import { render } from "./OrderTextCircle.vue?vue&type=template&id=66d3afaa&scoped=true"
import script from "./OrderTextCircle.vue?vue&type=script&lang=ts"
export * from "./OrderTextCircle.vue?vue&type=script&lang=ts"

import "./OrderTextCircle.vue?vue&type=style&index=0&id=66d3afaa&lang=less&scoped=true"
import "./OrderTextCircle.vue?vue&type=style&index=1&id=66d3afaa&lang=less"
script.render = render
script.__scopeId = "data-v-66d3afaa"

export default script